import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useCallback } from "react";
import { PaperclipIcon } from "lucide-react";
import { cn } from "../../../lib/utils";
import { Button } from "../../../components/base";
import { useUiTranslation } from "../../../i18n";
export const FileUploadButton = ({ className, disabled = false, accept, multiple = true, onFilesSelected, }) => {
    const { t } = useUiTranslation();
    const inputRef = useRef(null);
    const handleClick = useCallback(() => {
        inputRef.current?.click();
    }, []);
    const handleChange = useCallback((e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            onFilesSelected(Array.from(files));
        }
        // Reset input to allow selecting the same file again
        e.target.value = "";
    }, [onFilesSelected]);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { type: "button", variant: "ghost", size: "icon", className: cn("h-8 w-8", className), disabled: disabled, onClick: handleClick, title: t("chat.attachFile", "Attach file"), children: _jsx(PaperclipIcon, { className: "h-4 w-4" }) }), _jsx("input", { ref: inputRef, type: "file", className: "hidden", accept: accept, multiple: multiple, onChange: handleChange, disabled: disabled })] }));
};
//# sourceMappingURL=FileUploadButton.js.map